import { DropdownItem as _DropdownItem, DropdownItemProps as _DropdownItemProps } from "reactstrap";

    export const DropdownItem = _DropdownItem;
    export type DropdownItemProps = _DropdownItemProps;
    